import DataRoomNdaStatusBadge from './DataRoomNdaStatusBadge.component';

export default DataRoomNdaStatusBadge;
